const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20design%20with%20warm%20golden%20amber%20lighting%20and%20deep%20dramatic%20shadows%2C%20single%20heroic%20figure%20silhouette%20against%20epic%20sunset%20sky%2C%20film%20grain%20texture%2C%20blockbuster%20action%20movie%20aesthetic%2C%20professional%20poster%20design%20with%20bold%20composition%2C%20cinematic%20color%20grading%20warm%20tones&width=400&height=560&seq=card-poster-01&orientation=portrait',
    tag: '动作大片',
    title: '《暗夜追击》',
    meta: '4K · 2026',
    rating: '9.2',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Atmospheric%20romance%20movie%20poster%20with%20soft%20golden%20hour%20backlight%2C%20two%20figures%20in%20tender%20embrace%20silhouette%2C%20dreamy%20bokeh%20lights%20in%20background%2C%20warm%20nostalgic%20color%20palette%2C%20film%20grain%20texture%2C%20romantic%20drama%20cinema%20aesthetic%2C%20elegant%20poster%20composition&width=400&height=560&seq=card-poster-02&orientation=portrait',
    tag: '爱情文艺',
    title: '《那年星空下》',
    meta: '1080P · 2026',
    rating: '8.8',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20poster%20design%20with%20dark%20moody%20atmosphere%2C%20rain%20soaked%20urban%20street%20at%20night%20with%20neon%20reflections%2C%20lone%20figure%20under%20streetlamp%2C%20noir%20cinema%20style%20with%20high%20contrast%20lighting%2C%20suspenseful%20composition%2C%20professional%20film%20poster%20quality%20dark%20teal%20tones&width=400&height=560&seq=card-poster-03&orientation=portrait',
    tag: '悬疑惊悚',
    title: '《无声证词》',
    meta: '4K · 2026',
    rating: '9.0',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20cosmic%20nebula%20colors%2C%20astronaut%20silhouette%20floating%20in%20space%2C%20distant%20galaxy%20and%20stars%2C%20epic%20scale%20composition%2C%20deep%20purple%20and%20golden%20accents%2C%20professional%20film%20poster%20design%20with%20grand%20cinematic%20scope&width=400&height=560&seq=card-poster-04&orientation=portrait',
    tag: '科幻巨制',
    title: '《星际迷途》',
    meta: '4K HDR · 2026',
    rating: '8.5',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20animation%20movie%20poster%20with%20fantasy%20kingdom%20landscape%2C%20magical%20creatures%20and%20sparkling%20effects%2C%20vibrant%20warm%20color%20palette%2C%20whimsical%20storybook%20aesthetic%2C%20professional%20animated%20film%20visual%20quality%2C%20enchanting%20children%20movie%20composition&width=400&height=560&seq=card-poster-05&orientation=portrait',
    tag: '动画佳作',
    title: '《梦境奇旅》',
    meta: '1080P · 2026',
    rating: '9.5',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Intense%20drama%20movie%20poster%20with%20close-up%20portrait%20style%2C%20emotional%20expression%20half%20lit%20in%20dramatic%20chiaroscuro%20lighting%2C%20warm%20and%20cool%20color%20contrast%2C%20artistic%20film%20poster%20design%2C%20powerful%20human%20story%20atmosphere%2C%20professional%20cinema%20quality%20portrait&width=400&height=560&seq=card-poster-06&orientation=portrait',
    tag: '剧情佳片',
    title: '《归途》',
    meta: '1080P · 2026',
    rating: '8.7',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Comedy%20movie%20poster%20with%20bright%20warm%20lighting%2C%20playful%20group%20of%20characters%20in%20funny%20pose%2C%20colorful%20festive%20background%2C%20light-hearted%20feel-good%20atmosphere%2C%20professional%20film%20poster%20design%20with%20energetic%20composition%2C%20entertaining%20movie%20visual&width=400&height=560&seq=card-poster-07&orientation=portrait',
    tag: '爆笑喜剧',
    title: '《乌龙家族》',
    meta: '1080P · 2026',
    rating: '8.3',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-accent-400 mb-3">FEATURED</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">精选内容</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">本周编辑精选，高分好片不容错过</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
            {cards.map((c, i) => (
              <div key={i} className="group relative rounded-xl overflow-hidden border border-background-200/40 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
                <div className="aspect-[2/3] overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                    <div className="w-full">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-xs text-foreground-200 font-semibold">{c.rating}</span>
                        <span className="text-xs text-foreground-400">{c.meta}</span>
                      </div>
                      <div className="w-full h-8 rounded-md bg-primary-500/90 flex items-center justify-center text-background-50 text-xs font-medium cursor-pointer whitespace-nowrap">
                        <i className="ri-play-fill mr-1"></i>立即播放
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute top-2 left-2">
                  <span className="text-xs px-2 py-0.5 rounded bg-accent-500/90 text-background-50 font-medium whitespace-nowrap">{c.tag}</span>
                </div>
                <div className="p-3">
                  <h3 className="text-sm font-semibold text-foreground-100 truncate">{c.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}